import { render, staticRenderFns } from "./realnameCheck.vue?vue&type=template&id=24ae4864&scoped=true&"
import script from "./realnameCheck.vue?vue&type=script&lang=js&"
export * from "./realnameCheck.vue?vue&type=script&lang=js&"
import style0 from "./realnameCheck.vue?vue&type=style&index=0&id=24ae4864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ae4864",
  null
  
)

export default component.exports